module.exports = __webpack_public_path__ + "img/daikuan2.fd8e1bfa.png";